/** Formatadores compartilhados das abas de Inteligência de Mercado. */
import { num } from './charts/chartTheme';

export const brl = (v: number | string | null | undefined) =>
  v == null || v === ''
    ? '—'
    : new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 }).format(num(v));

export const brl2 = (v: number | string | null | undefined) =>
  v == null || v === ''
    ? '—'
    : new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(num(v));

export const nInt = (v: number | string | null | undefined) =>
  new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(num(v));

export const dataBR = (v: string | null | undefined) => {
  if (!v) return '—';
  const d = new Date(`${String(v).slice(0, 10)}T00:00:00`);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('pt-BR');
};

/** Link de busca no PNCP (robusto; evita montar URL canônica frágil). */
export const pncpBusca = (q: string) =>
  `https://pncp.gov.br/app/contratos?q=${encodeURIComponent(q)}`;
